import axios from 'axios';
import { API_URL } from './apiConfig';
import { handleAuthError } from './handleAuthError';
import i18n from 'i18next';

/**
 * Creates an axios instance with authentication
 * Automatically adds the Authorization header
 * Should be used for API requests
 */
const axiosWithAuth = () => {
  // Get token from local storage
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  
  // Get current language for Accept-Language header
  const currentLanguage = i18n.language || 'az';
  
  // Log token status for debugging
  if (process.env.NODE_ENV !== 'production') {
    console.log(`Auth Token exists: ${!!token}`);
    if (token) {
      // Show first and last 5 characters of the token, hide the middle
      const tokenLength = token.length;
      if (tokenLength > 15) {
        const firstFive = token.substring(0, 5);
        const lastFive = token.substring(tokenLength - 5);
        console.log(`Token: ${firstFive}...${lastFive} (${tokenLength} characters)`);
      }
    }
  }

  // Create axios instance
  const instance = axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Accept-Language': currentLanguage,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    withCredentials: true
  });

  // Interceptor for requests
  instance.interceptors.request.use(
    (config) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('Request:', {
          url: config.url,
          method: config.method,
          headers: config.headers
        });
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Interceptor for responses
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Response Error:', error.response || error);
      }
      
      // Use our auth error handler for 401 responses
      return handleAuthError(error);
    }
  );

  return instance;
};

export default axiosWithAuth; 